<template>
    <layout-basic class="404-section">
        <section  class="section">
            <div class="container has-text-centered">
                <div class="columns is-centered">
                    <div class="column is-7" style="margin-top: 40px;">
                        <h1 class="title is-1" data-config-id="header">404</h1>
                        <p class="subtitle is-3" data-config-id="subheader">Page not found</p>
                    </div>
                </div><a class="button is-primary" href="/" data-config-id="primary-action">Back to homepage</a>
            </div>
        </section>
    </layout-basic>
</template>

<script>
import LayoutBasic from '@/layouts/LayoutBasic'
import globalPackageVersion from 'global-package-version'
import { mapGetters } from 'vuex'

export default {
  name: 'Home',
  components: {
    LayoutBasic
  },

  data () {
    return {
      backendVersions: {},
      frontendVersions: {},
      isLoading: false
    }
  },

  computed: {
    ...mapGetters({currentUser: "auth/currentUser"})
  },

  mounted () {
    globalPackageVersion(require('@/../package.json'))
    globalPackageVersion(require('vue-router/package.json'))
    globalPackageVersion(require('vuex/package.json'))
    globalPackageVersion(require('buefy/package.json'))
    globalPackageVersion(require('bulma/package.json'))
    globalPackageVersion(require('axios/package.json'))
    globalPackageVersion(require('webpack/package.json'))
  }
}
</script>
